const tr = {
    en: {
        paymentPrompt: "Setup 1O1O/csl/Club Sim Subscriptions",
        paymentPrompt2: "Please enter your mobile number",
        
        paymentPrompt3: "Sign in / create an account with",
        paymentPrompt4: "First time signing in with mobile number?",

        noMobileNoInput: "Enter 1O1O / csl / Club Sim Mobile Number",
        invalidMobileNo: "Mobile number is not correct, please try again.",
        bindingSaveRequired: "You must agree to save your mobile number to continue.",
        inputPlaceholder: "Enter 1O1O/csl/Club Sim mobile number",

        alertBtnTxt:"See important notes",

        saveCheckboxTxt1:"I confirm that I have attained the age of 18 years old. I have read and accepted the ",
        saveCheckboxTxt2:"Now E Terms and Conditions",
        saveCheckboxTxt3:" and the ",
        saveCheckboxTxt4:"Privacy Statement of the HKT Group.",
		saveCheckboxTxt5:"I agree to the registration of a Now E account under the mobile number I provided above if no Now E account has been registered under such mobile number.",
        saveCheckboxTxt6:"I agree to the disclosure of my 1O1O / csl / Club Sim mobile number above by PCCW Media Limited to CSL Mobile Limited (“CSL”) for provision of the Now E service and directly related purposes. Upon clicking “Continue”, I will be diverted to the login page at CSL to log in to my mobile service account and be routed back to Now E webpage upon successful login.",
        
        termsConditionUrl:"https://www.nowe.com/tnc/service",
        privacyStatementUrl:"https://www.pccw.com/privacy-statement/index.page?locale=en",

        continueBtnTxt: "Continue",
        cancelBtnTxt: "Back",

        dialogTitleTxt:"First time signing in with mobile number?",
        dialogTxt1:"If the number is currently linked to a Now E account",
        dialogTxt2:"We’ll sign you into the account. The number will then be permanently linked. (You won’t be able to link it to other accounts to watch. See FAQ.)",
        dialogTxt3:"If the number is not being linked",
        dialogTxt4:"We’ll create a new account. The subscriptions purchased through the corresponding mobile operator will be activated.",
        dialogTxt5:"If you have an existing Now E account but haven’t linked to your mobile number",
        dialogTxt6:"Please link it first to ensure you can watch all your subscriptions through one account. ",
        dialogUrlTxt:"Sign in with your email",
        dialogTxt7:" first, then select ",
        dialogTxt8:"Set up 1O1O / csl / Club Sim Subscriptions",
        dialogTxt9:" from the main menu at NowE.com.",
        dialogTxt10:"Signing in with your mobile number will also set up billing through your mobile operator as the payment option for any future purchases.",
        dialogTxt11:"If you have any doubts about whether your 1O1O / csl / Club Sim mobile number is being linked to your existing Now E account, please contact customer support for further information.",
        okButtonTxt:"OK",
    },
    zh: {
        paymentPrompt: "設定1O1O/csl/Club Sim計劃或組合",
        paymentPrompt2: "請輸入您的手機號碼",
        paymentPrompt3: "請以下列其一方式登入或建立帳戶",
        paymentPrompt4: "首次使用流動電話號碼登入？",

        noMobileNoInput: "輸入 1O1O / csl / Club Sim 流動電話號碼",
        invalidMobileNo: "手機號碼不正確，請重新輸入。",
        bindingSaveRequired: "You must agree to save your mobile number to continue.",
        inputPlaceholder: "輸入 1O1O/csl/Club Sim 流動電話號碼",

        alertBtnTxt:"查閱重要提示",

        saveCheckboxTxt1: "本人確認我已年滿18歲,並已閱讀及同意有關",
        saveCheckboxTxt2:"Now E 條款及條件",
        saveCheckboxTxt3:"及",
        saveCheckboxTxt4:"香港電訊集團的私隱聲明",
		saveCheckboxTxt5:"以登記Now E帳戶（如我的流動電話號碼服務賬戶下未有登記）。",
        saveCheckboxTxt6:"本人同意電訊盈科媒體有限公司向香港移動通訊有限公司(“CSL”)披露本人上列之 1O1O / csl / Club Sim 之流動電話號碼以提供 Now E 服務及直接相關的目的，並按以下“繼續”跳轉至CSL的登入頁面，在成功登入流動通訊服務帳戶後返回Now E頁面。",

        termsConditionUrl:"https://www.nowe.com/tnc/service",
        privacyStatementUrl:"https://www.pccw.com/privacy-statement/index.page?locale=zh",

        continueBtnTxt: "繼續",
        cancelBtnTxt: "返回",

        dialogTitleTxt:"首次使用流動電話號碼登入？",
        dialogTxt1:"如果該流動電話號碼已連接到 Now E 帳戶",
        dialogTxt2:"我們將為您登入該帳戶，並將號碼永久連接在一起。（您將無法連接該號碼到其他帳戶以觀看訂購服務，詳情請參閱常見問題。）",
        dialogTxt3:"如果該流動電話號碼尚未連接到任何帳戶",
        dialogTxt4:"我們將為您建立一個新帳戶，並啟用透過相應的流動服務營辦商支付訂購服務之費用。",
        dialogTxt5:"如果您已經擁有一個 Now E 帳戶，但尚未連接到您的流動電話號碼",
        dialogTxt6:"請先連接號碼到您現有的帳戶，以確保您可以通過同一個帳戶觀看所有訂購的服務。步驟如下：首先",
        dialogUrlTxt:"使用您的電郵登入",
        dialogTxt7:"，然後從 NowE.com 的帳戶選單中選擇",
        dialogTxt8:"啟用 1O1O / csl / Club Sim 服務",
        dialogTxt9:"，以完成連接程序。",
        dialogTxt10:"使用流動電話號碼登入亦會設置您的流動服務營辦商為將來任何訂購的付款方式。",
        dialogTxt11:"如果您對您的1O1O / csl / Club Sim 流動電話號碼是否已連接到您現有的 Now E 帳戶存有任何疑問，請聯絡我們以查詢有關資料。",
        okButtonTxt:"確定",
    }
}

export default tr;
